import { C } from "../constants";

export function Sec({ children, bg, style }) {
  return (
    <section style={{ padding: "72px 24px", background: bg || "transparent", ...style }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>{children}</div>
    </section>
  );
}

export function STitle({ tag, title, sub }) {
  return (
    <div style={{ textAlign: "center", marginBottom: 44 }}>
      {tag && <span style={{
        display: "inline-block", background: C.blueLight, color: C.blueDark,
        fontFamily: "'Nunito', sans-serif", fontWeight: 700, fontSize: 12.5,
        padding: "5px 14px", borderRadius: 20, marginBottom: 14, textTransform: "uppercase", letterSpacing: 1.2
      }}>{tag}</span>}
      <h2 style={{
        fontFamily: "'Nunito', sans-serif", fontWeight: 800, fontSize: "clamp(26px, 4vw, 38px)",
        color: C.text, margin: "0 0 10px", lineHeight: 1.2
      }}>{title}</h2>
      {sub && <p style={{
        fontFamily: "'Nunito', sans-serif", color: C.textMid, fontSize: 16, maxWidth: 600, margin: "0 auto", lineHeight: 1.65
      }}>{sub}</p>}
    </div>
  );
}

export function Crd({ icon, title, desc, accent }) {
  return (
    <div style={{
      background: C.white, borderRadius: 16, padding: 28,
      border: `1px solid ${C.border}`, transition: "transform 0.2s, box-shadow 0.2s"
    }}
      onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 10px 28px rgba(0,0,0,0.07)"; }}
      onMouseLeave={e => { e.currentTarget.style.transform = ""; e.currentTarget.style.boxShadow = ""; }}
    >
      <div style={{
        width: 46, height: 46, borderRadius: 12, background: accent || C.blueLight,
        display: "flex", alignItems: "center", justifyContent: "center", fontSize: 21, marginBottom: 14
      }}>{icon}</div>
      <h3 style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 700, fontSize: 17, color: C.text, margin: "0 0 6px" }}>{title}</h3>
      <p style={{ fontFamily: "'Nunito', sans-serif", color: C.textMid, fontSize: 14.5, lineHeight: 1.65, margin: 0 }}>{desc}</p>
    </div>
  );
}

export function Btn({ children, primary, onClick, style: s }) {
  return (
    <button onClick={onClick} style={{
      fontFamily: "'Nunito', sans-serif", fontWeight: 700, fontSize: 15,
      padding: "13px 26px", borderRadius: 10, border: "none", cursor: "pointer",
      background: primary ? C.blue : C.white,
      color: primary ? "#fff" : C.text,
      boxShadow: primary ? "0 4px 14px rgba(59,154,232,0.35)" : `inset 0 0 0 1.5px ${C.border}`,
      transition: "all 0.2s", ...s
    }}
      onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
      onMouseLeave={e => e.currentTarget.style.transform = ""}
    >{children}</button>
  );
}

export function ContentBlock({ icon, title, children }) {
  return (
    <div style={{
      background: C.white, borderRadius: 16, padding: "28px 32px",
      border: `1px solid ${C.border}`, marginBottom: 20
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
        <span style={{ fontSize: 22 }}>{icon}</span>
        <h3 style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 700, fontSize: 18, color: C.text, margin: 0 }}>{title}</h3>
      </div>
      <div style={{ fontFamily: "'Nunito', sans-serif", color: C.textMid, fontSize: 15, lineHeight: 1.75 }}>
        {children}
      </div>
    </div>
  );
}

export function Step({ num, title, desc, color }) {
  return (
    <div style={{ display: "flex", gap: 20, marginBottom: 32 }}>
      <div style={{
        width: 52, height: 52, borderRadius: 14, flexShrink: 0,
        background: color || C.blueLight, display: "flex", alignItems: "center", justifyContent: "center",
        fontFamily: "'Nunito', sans-serif", fontWeight: 900, fontSize: 22, color: C.blueDark
      }}>{num}</div>
      <div>
        <h3 style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 700, fontSize: 17, color: C.text, margin: "0 0 4px" }}>{title}</h3>
        <p style={{ fontFamily: "'Nunito', sans-serif", color: C.textMid, fontSize: 14.5, lineHeight: 1.65, margin: 0 }}>{desc}</p>
      </div>
    </div>
  );
}
